(function () {
  'use strict';

  var EBOOK_THRESHOLD = 5900;       // $59 in cents
  var SHIPPING_THRESHOLD = 8900;    // $89 in cents
  var ASHWAGANDHA_GIFT_THRESHOLD = 7900; // $79 in cents
  var MONEY_FORMAT = Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var root = document.getElementById('bcart');
  if (!root) return;

  var panel = root.querySelector('.bcart__panel');
  var itemsEl = root.querySelector('[data-bcart-items]');
  var totalEl = root.querySelector('[data-bcart-total]');
  var subtotalEl = root.querySelector('[data-bcart-subtotal]');
  var progressText = root.querySelector('[data-bcart-progress-text]');
  var progressRemaining = root.querySelector('[data-bcart-remaining]');
  var progressNextLabel = root.querySelector('[data-bcart-next-label]');
  var fillEl = root.querySelector('[data-bcart-fill]');
  var checkoutBtn = root.querySelector('[data-bcart-checkout]');
  var discountForm = root.querySelector('[data-bcart-discount-form]');
  var discountInput = root.querySelector('[data-bcart-discount-input]');
  var tpl = document.getElementById('bcart-item-tpl');

  function open(showAshwagandhaGift) {
  root.classList.add('bcart--open');
  root.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bcart-locked');

  refresh().then(function(cart) {
    if (showAshwagandhaGift) {
      maybeShowAshwagandhaGift(cart);
    }
  });
}

  function close() {
    root.classList.remove('bcart--open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bcart-locked');
    hideAllPopups();
  }

  function hideAllPopups() {
    root.querySelectorAll('.bcart__popup').forEach(function (p) { p.hidden = true; });
  }

  function toggleCheckpoint(name, unlocked) {
    var btn = root.querySelector('[data-bcart-checkpoint="' + name + '"]');
    if (!btn) return;
    btn.classList.toggle('bcart__checkpoint--unlocked', unlocked);
    var inactive = btn.querySelector('[data-bcart-icon-inactive]');
    var active = btn.querySelector('[data-bcart-icon-active]');
    if (inactive) inactive.hidden = unlocked;
    if (active) active.hidden = !unlocked;
  }

  function showPopup(name) {
    hideAllPopups();
    var p = root.querySelector('[data-bcart-popup="' + name + '"]');
    if (p) p.hidden = false;
  }
function shouldShowAshwagandhaGift(cart) {
  if (!cart || !cart.items || cart.items.length === 0) return false;

  var hasAshwagandha = cart.items.some(function(item) {
    var title = (item.product_title || '').toLowerCase();

    return title.includes('ashwagandha') &&
           title.includes('shilajit') &&
           title.includes('saffron');
  });

  return hasAshwagandha && cart.total_price >= ASHWAGANDHA_GIFT_THRESHOLD;
}
function isAshwagandhaProduct(item) {
  if (!item) return false;

  var title = (item.product_title || '').toLowerCase();

  return title.includes('ashwagandha') &&
         title.includes('shilajit') &&
         title.includes('saffron');
         }
function maybeShowAshwagandhaGift(cart) {
  if (shouldShowAshwagandhaGift(cart)) {
    showPopup('ashwagandha-gift');
  }
}
  // Close handlers
  root.querySelectorAll('[data-bcart-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  root.querySelectorAll('[data-bcart-popup-close]').forEach(function (el) {
    el.addEventListener('click', hideAllPopups);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('bcart--open')) close();
  });

  // Checkpoint clicks
  root.querySelectorAll('[data-bcart-checkpoint]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      showPopup(btn.getAttribute('data-bcart-checkpoint'));
    });
  });

  function updateProgress(subtotal) {
    var remaining;
    var nextLabel;
    var targetMax;

    if (subtotal < EBOOK_THRESHOLD) {
      remaining = EBOOK_THRESHOLD - subtotal;
      nextLabel = 'FREE EBOOK';
      targetMax = EBOOK_THRESHOLD;
    } else if (subtotal < SHIPPING_THRESHOLD) {
      remaining = SHIPPING_THRESHOLD - subtotal;
      nextLabel = 'FREE SHIPPING';
      targetMax = SHIPPING_THRESHOLD;
    } else {
      remaining = 0;
      nextLabel = 'all rewards unlocked';
      targetMax = SHIPPING_THRESHOLD;
    }

    if (progressRemaining) progressRemaining.textContent = (remaining / 100).toFixed(2);
    if (progressNextLabel) progressNextLabel.textContent = nextLabel;

    // Fill bar: proportional to subtotal / shipping threshold, capped at 100%
    var pct = Math.min(100, (subtotal / SHIPPING_THRESHOLD) * 100);
    if (fillEl) fillEl.style.width = pct + '%';

    // Toggle active/inactive icons per checkpoint
    toggleCheckpoint('ebook', subtotal >= EBOOK_THRESHOLD);
    toggleCheckpoint('shipping', subtotal >= SHIPPING_THRESHOLD);

    if (progressText && remaining === 0) {
      progressText.innerHTML = "🎉 You've unlocked <strong>FREE SHIPPING</strong> and your <strong>FREE EBOOK</strong>!";
    } else if (progressText) {
      progressText.innerHTML = 'You are <strong>$<span data-bcart-remaining>' + (remaining / 100).toFixed(2) + '</span></strong> away from <strong data-bcart-next-label>' + nextLabel + '</strong>';
    }
  }

  function renderItem(item) {
    var node = tpl.content.cloneNode(true);
    var article = node.querySelector('.bcart__item');
    article.setAttribute('data-key', item.key);

    var img = node.querySelector('.bcart__item-img');
    img.src = item.image ? item.image.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_200x.') : '';
    img.alt = item.product_title || '';

    // This landing page is dedicated to one product — always render the red italic
    // "America's Favorite" prefix. If the product title already includes that phrase,
    // strip it from the rest so we don't render it twice.
    var title = item.product_title || '';
    var emPart = "America's Favorite";
    var restPart = title;
    var match = title.match(/^(America'?s Favorite)\s+(.*)$/i);
    if (match) {
      restPart = match[2];
    }
    node.querySelector('[data-bcart-item-title-em]').textContent = emPart;
    node.querySelector('[data-bcart-item-title-rest]').textContent = ' ' + restPart;

    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
    else if (item.product_type) meta.push(item.product_type);
    node.querySelector('[data-bcart-item-meta]').textContent = meta.join(' · ') || '1200mg / 60 Capsules';

    node.querySelector('[data-bcart-item-price]').textContent = fmt(item.final_line_price);
    node.querySelector('[data-bcart-qty]').textContent = item.quantity;

    var minus = node.querySelector('[data-bcart-qty-minus]');
    var plus = node.querySelector('[data-bcart-qty-plus]');
    var remove = node.querySelector('[data-bcart-remove]');

    minus.addEventListener('click', function () { changeQty(item.key, item.quantity - 1); });
    plus.addEventListener('click', function () { changeQty(item.key, item.quantity + 1); });
    remove.addEventListener('click', function () { changeQty(item.key, 0); });

    return node;
  }

  function renderEmpty() {
    itemsEl.innerHTML = '<p class="bcart__empty">Your cart is empty.</p>';
    if (totalEl) totalEl.textContent = '$0.00';
    if (subtotalEl) subtotalEl.textContent = '$0.00';
    updateProgress(0);
  }

  function render(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      renderEmpty();
      return;
    }
    itemsEl.innerHTML = '';
    cart.items.forEach(function (item) { itemsEl.appendChild(renderItem(item)); });
    if (totalEl) totalEl.textContent = fmt(cart.total_price);
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
    updateProgress(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
  return fetchCart()
    .then(function(cart) {
      render(cart);
      return cart;
    })
    .catch(function(e) {
      console.error('[bcart] fetch', e);
      return null;
    });
}

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (e) { console.error('[bcart] change', e); });
  }

  // Discount code — Shopify redirects to checkout with discount param.
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (discountInput.value || '').trim();
      if (!code) return;
      // Append to checkout URL (Shopify auto-applies via /discount/CODE)
      checkoutBtn.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      discountForm.classList.add('bcart__discount--applied');
    });
  }

  // Expose controller
  window.BerberineCart = {
    open: open,
    close: close,
    refresh: refresh
  };

  // Intercept product form submits — add to cart via AJAX, then open drawer
  function interceptProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.bcartBound) return;
      form.dataset.bcartBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var btn = form.querySelector('button[type="submit"], [name="add"]');
        var origLabel = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'ADDING...'; }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function (addedItem) {
  if (btn) {
    btn.textContent = 'ADDED ✓';
    setTimeout(function () {
      btn.textContent = origLabel;
      btn.disabled = false;
    }, 800);
  }

  open(isAshwagandhaProduct(addedItem));
})
          .catch(function (err) {
            console.error('[bcart] add', err);
            if (btn) { btn.textContent = origLabel; btn.disabled = false; }
            alert((err && err.description) || 'Could not add to cart.');
          });
      });
    });
  }

  interceptProductForms();

  // Re-bind after DOM changes (e.g., template swaps)
  new MutationObserver(interceptProductForms).observe(document.body, { childList: true, subtree: true });

  // Open drawer when clicking cart icon/link
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart], a[href="/cart"], a[href$="/cart"]');
    if (t) {
      e.preventDefault();
      open();
    }
  });

  // Initial refresh so progress bar is accurate on load
  refresh();
})();
